export const areOptionsOfEqualValue = <T extends { value: unknown }>(
  a: T,
  b: T
) => Boolean(a && b && a.value === b.value)
